import type { SecretBonusHandTuning } from "../features/secret-bonus/SecretBonusView";
import { GRID_GEOMETRY } from "../scene/GridContainer";

// The Secret Bonus hand's VALUES — the only file to edit to retune it: where its fingertip rests on the disc, its size and
// its tap. The shape is the view's.

export const SECRET_BONUS_HAND_TUNING: SecretBonusHandTuning = {
  // The whole cell answers the tap.
  cellSize: GRID_GEOMETRY.pitch,
  // The fingertip on the disc under its lettering, the hand reaching out past the cell's lower right corner: the layout
  // example's pose (its hand matched over the art there).
  tipX: 6,
  tipY: 29,
  height: 100,
  // The fingertip in the hand art (138 × 132): its top-left, measured on the export.
  tipAnchorX: 0.11,
  tipAnchorY: 0.04,
  // A press towards the disc and back, about once a second.
  periodSeconds: 0.95,
  pressDistance: 12,
  pressScale: 0.92,
};
